import React from 'react';

interface GimacIconProps {
  className?: string;
  height?: number;
}

export const GimacIcon: React.FC<GimacIconProps> = ({ className, height = 40 }) => (
  <svg
    width={height * (83 / 87)}
    height={height}
    viewBox="0 0 83 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="img"
    aria-label="GIMAC"
  >
    <path
      d={
        'M29.3111 1.78122L28.2644 4.85104L16.7255 6.81941C16.1958 6.75396 ' +
        '15.0047 4.72527 14.4627 4.32006L29.3133 1.78084L29.3111 1.78122Z'
      }
      fill="#8D8D8D"
    />
    <path
      d={
        'M59.194 3.06599C60.1428 2.69728 62.4136 2.66692 63.5041 2.68465' +
        'C71.9967 2.81333 79.8434 8.74467 82.3581 16.8633C82.9611 18.8068 ' +
        '83.8226 22.1009 80.6333 21.9924C78.6395 21.9249 78.7535 19.6799 ' +
        '78.345 18.3915C76.0836 11.2712 69.8282 6.83667 62.3766 6.9728' +
        'C61.2468 6.9939 59.6614 7.59765 58.6759 6.81173C57.403 5.79502 ' +
        '57.6674 3.66429 59.1922 3.0686L59.194 3.06599Z'
      }
      fill="#8D8D8D"
    />
    <path
      d={
        'M71.1375 23.0814C70.263 22.4624 70.2322 21.0474 69.8272 20.0613' +
        'C68.5373 16.9184 65.8307 15.688 62.6141 15.5405C61.5134 15.4901 ' +
        '60.1318 16.0108 59.5203 14.5277C57.954 10.7346 63.6862 11.0897 ' +
        '65.8492 11.5963C69.9028 12.546 74.5798 17.0484 74.5304 21.4023' +
        'C74.511 23.0598 72.4762 24.0272 71.1375 23.0814Z'
      }
      fill="#8D8D8D"
    />
    <path
      d={
        'M70.4057 39.8544C70.0474 50.3054 61.2835 58.4883 50.8325 58.1301' +
        'C40.3815 57.7718 32.1986 49.008 32.5568 38.5569C32.9151 28.1059 ' +
        '41.6789 19.923 52.13 20.2812C62.581 20.6395 70.7639 29.4033 ' +
        '70.4057 39.8544ZM53.9335 28.2675C53.9234 26.7126 54.5465 24.1158 ' +
        '52.4203 23.6945C49.7524 23.1663 49.6804 26.2571 49.6642 28.1143' +
        'C41.992 29.4059 40.5798 37.5286 48.252 40.5318C49.902 41.179 ' +
        '55.375 42.1269 55.8518 43.9286C56.0862 44.8146 55.4534 45.3858 ' +
        '54.7136 45.7112C52.6527 46.6181 48.2164 46.3212 46.9633 44.1942' +
        'C46.4309 43.2889 46.673 42.4984 45.4102 42.041C43.9014 41.496 ' +
        '42.4619 42.5622 42.5668 44.1905C42.7507 47.0118 46.2557 49.7206 ' +
        '48.9379 49.9642C48.8677 51.6815 48.4865 54.6169 50.8953 54.781' +
        'C53.3041 54.945 53.1737 51.9491 53.1631 50.2787C60.9125 49.8384 ' +
        '62.8508 41.6161 55.3093 38.3661C53.4674 37.5721 49.1266 36.8666 ' +
        '47.9232 35.5989C46.9667 34.5908 47.4345 33.4189 48.5597 32.808' +
        'C50.4113 31.8012 54.9232 32.069 56.0657 34.0565C56.275 34.4212 ' +
        '56.277 34.824 56.5571 35.2364C57.8994 37.2035 60.6376 36.0099 ' +
        '60.3013 33.5409C59.9255 30.7742 56.4878 28.6741 53.9334 28.2697' +
        'L53.9335 28.2675Z'
      }
      fill="#00AD00"
    />
    <path
      d={
        'M9.76087 5.16071L14.0451 10.398L14.6016 10.647L31.5918 7.7534' +
        'L34.0937 0.95659C35.8925 0.782105 37.7998 0.169194 39.5774 ' +
        '0.0189636C42.3597 -0.21356 44.8738 1.74266 45.5653 4.40513' +
        'L47.5993 16.3411C42.7334 17.3498 38.3216 19.5243 34.8584 ' +
        '23.0876C23.7419 34.5167 27.394 53.5683 41.8267 60.2319' +
        'C46.1337 62.2212 50.7195 62.6875 55.417 62.0632L57.4927 ' +
        '74.4578C57.4734 76.6797 56.3685 78.5367 54.471 79.6503' +
        'C42.3697 82.3275 29.9474 83.9329 17.725 86.1972C14.863 ' +
        '86.2185 12.434 84.25 11.8416 81.4559L0.00462184 12.053' +
        'C-0.0674839 10.0211 0.791005 8.07789 2.47739 6.91082' +
        'C4.45662 5.53766 7.4446 5.68983 9.76087 5.16071ZM31.8299 ' +
        '74.0369C30.2204 74.6608 30.1267 77.1318 31.7131 77.8356' +
        'C32.793 78.314 36.2211 77.7393 37.1899 77.0988C38.9503 ' +
        '75.9351 37.9406 73.21 35.7928 73.3157C35.0215 73.3535 ' +
        '32.5077 73.7741 31.8299 74.0369Z'
      }
      fill="#8D8D8D"
    />
  </svg>
);
